import React, { useState, useEffect } from "react";
import MiniDrawer from "../../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable from "mui-datatables";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import NewOrder from "./components/NewOrder";
import Order from "./components/Order";
import useSave from "../../../Hooks/useSave";
import PrintIcon from "@mui/icons-material/Print";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import useProtectView from "../../../Hooks/useProtectView";
import NewOrderCustomer from "./components/NewOrderCustomer";

export default function Orders() {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId } = useParams();
  const { fetchGraphql, DialogSave } = useSave();
  const canView = useProtectView();

  const [data, setData] = useState([]);

  //create date
  const today = new Date();
  const est2 = new Date(today.getTime() + -240 * 60 * 1000);
  const est3 = new Date(today.getTime() + -240 * 60 * 1000);
  const tomorow = new Date(est2.setDate(est3.getDate() + 1));
  const tomorowNoTime = new Date(tomorow.setHours(0, 0, 0, 0));

  const [fromDate, setFromDate] = useState(tomorowNoTime);

  const tomorowEndofDay = new Date(tomorow.setHours(23, 59, 59, 999));
  const [toDate, setToDate] = useState(tomorowEndofDay);

  useEffect(() => {
    fetchGraphql({
      query: `query Orders($customerId: ID, $options: optionsInput) {
        orders(customerId: $customerId, options: $options) {
          paymentStatus
          packDate
          orderedVia
          orderStatus
          orderId
          orderDate
          lastEditedBy
          deliveryDate
          customerName
          customerId
          createdBy
        }
      }`,
      variables: {
        options: { deliveryFromDate: fromDate, deliveryToDate: toDate },
        customerId,
      },
    }).then((result) => setData(result.data.orders));

    return () => {};
  }, []);

  const columns = [
    {
      name: "orderId",
      label: "Order Id",
    },
    {
      name: "orderDate",
      label: "Order Date",
    },
    {
      name: "packDate",
      label: "Pack Date",
    },
    {
      name: "deliveryDate",
      label: "Delivery Date",
      options: {
        filter: true,
        display: "true",
        filterType: "custom",
        // customFilterListOptions: {
        //   render: (v) => v.map((l) => l.toUpperCase()),
        //   update: (filterList, filterPos, index) => {
        //     console.log("update");
        //     console.log(filterList, filterPos, index);
        //     filterList[index].splice(filterPos, 1);
        //     return filterList;
        //   },
        // },
        filterOptions: {
          logic: (location, filters, row) => {
            // console.log("logic",location, filters, row);
            // if (filters.length) return !filters.includes(location);
            return false;
          },
          display: (filterList, onChange, index, column) => {
            return (
              <Box>
                <Typography sx={{ marginBottom: "10px" }}>
                  Delivery Date
                </Typography>

                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="From Date"
                    sx={{ marginBottom: "10px" }}
                    openTo="day"
                    views={["year", "month", "day"]}
                    shouldDisableDate={(date) => {
                      const today = new Date();
                      const todayDate = new Date(date);

                      // if (date < today.setDate(today.getDate() - 1))
                      //   return true;

                      if (date > toDate) return true;

                      // if (todayDate.getDay() === 6) return true;
                    }}
                    value={fromDate || tomorow}
                    onChange={(newValue) => {
                      setFromDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <Box sx={{ marginTop: "10px" }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="To Date"
                      openTo="day"
                      views={["year", "month", "day"]}
                      // shouldDisableDate={(date) => {
                      //   const today = new Date();
                      //   const todayDate = new Date(date);

                      //   if (date < today.setDate(today.getDate() - 1))
                      //     return true;

                      //   if (todayDate.getDay() === 6) return true;
                      // }}
                      value={toDate || tomorow}
                      onChange={(newValue) => {
                        setToDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
            );
          },
        },
      },
    },
    {
      name: "orderedVia",
      label: "Ordered Via",
    },
    {
      name: "createdBy",
      label: "Created By",
    },
    {
      name: "lastEditedBy",
      label: "Last Edited By",
    },
    {
      name: "customerName",
      label: "Customer name",
    },
    {
      name: "orderStatus",
      label: "Status",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          display: "flex",
          justifyContent: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              label={value}
              color={
                value === "Draft"
                  ? "secondary"
                  : value === "Submited"
                  ? "primary"
                  : "success"
              }
            />
          );
        },
      },
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
    },
  ];

  const handleFilterSubmit = (applyFilters) => {
    let filterList = applyFilters();

    // console.log(filterList);
    // this.setState({ isLoading: true });

    // // fake async request
    // this.xhrRequest(`/myApiServer?filters=${filterList}`, filterList).then(
    //   (res) => {
    //     this.setState({ isLoading: false, data: res.data });
    //   }
    // );
  };

  const options = {
    filterType: "multiselect",
    responsive: "scroll",
    onRowClick: (rowData) => {
      navigate(`order/${rowData[0]}/order`);
    },
    filter: true, // show the filter icon in the toolbar (true by default)
    serverSide: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [50],

    // makes it so filters have to be "confirmed" before being applied to the
    // table's internal filterList
    confirmFilters: true,

    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <IconButton>
        <Tooltip title="Print Orders">
          <PrintIcon />
        </Tooltip>
      </IconButton>
    ),

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => {
              fetchGraphql({
                query: `query Orders($customerId: ID, $options: optionsInput) {
                  orders(customerId: $customerId, options: $options) {
                    paymentStatus
                    packDate
                    orderedVia
                    orderStatus
                    orderId
                    orderDate
                    lastEditedBy
                    deliveryDate
                    customerName
                    customerId
                    createdBy
                  }
                }`,
                variables: {
                  options: {
                    deliveryFromDate: fromDate,
                    deliveryToDate: toDate,
                  },
                  customerId,
                },
              }).then((result) => setData(result.data.orders));

              handleFilterSubmit(applyNewFilters);
            }}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      // console.log("onFilterConfirm");
      console.dir(filterList);
    },

    onFilterDialogOpen: () => {
      // console.log("filter dialog opened");
    },
    onFilterDialogClose: () => {
      // console.log("filter dialog closed");
    },
    onFilterChange: (column, filterList, type) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        // console.log("updating filters via chip");
        handleFilterSubmit(newFilters);
      }
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <DialogSave />
      <Routes>
        <Route
          path="/"
          element={
            <Button
              variant="contained"
              sx={{ margin: "0px 0px 20px auto" }}
              onClick={() => {
                fetchGraphql({
                  query: `mutation CreateOrder($order: orderInput) {
                      createOrder(order: $order)
                    }`,
                  variables: {
                    order: {
                      customerId: null,
                      deliveryDate: null,
                      orderedVia: canView("onlySelf") ? "Customer" : "Office",
                      orderStatus: "Draft",
                      orderNote: null,
                    },
                  },
                }).then((result) => {
                  navigate(`new-order-customer/${result.data.createOrder}`);
                });
              }}
            >
              <AddIcon />
              New Order
            </Button>
          }
        />

        <Route
          path="/*"
          element={
            <Button
              variant="outlined"
              sx={{ margin: "0px auto 20px 0px  " }}
              onClick={() => navigate("/orders")}
            >
              <ArrowBackIcon />
              Back
            </Button>
          }
        />
      </Routes>

      <Routes>
        <Route
          path="/"
          element={
            <ThemeProvider
              theme={createTheme({
                components: {
                  MUIDataTable: {
                    paper: {
                      height: "inherit",
                    },
                    responsiveScroll: {
                      maxHeight: "none",
                      height: "calc(100% - 128px)",
                    },
                  },
                },
              })}
            >
              <MUIDataTable
                title={"Orders"}
                data={data}
                columns={columns}
                options={options}
              />
            </ThemeProvider>
          }
        />

        <Route path="/new-order" element={<NewOrder />} />
        <Route path="/new-order-customer/:id" element={<NewOrderCustomer />} />
        {/* <Route path="/order/:id/*" element={<Order />} /> */}
      </Routes>
    </Box>
  );
}
